const BACKEND_BASE_URI = '/qnb/api';

module.exports = {

    /**
     * Defines the prefix url where the set of states for a sub module should
     * plug into the portal application
     */
    state_plugin_config: {
        quote_bind: 'root',
        home: 'home',
        quickQuote: 'quickQuote',
    },

    httpSettings: {
        timeout: 90000,
        reloadQueryParamName: 'goto',
        reloadURL: '/index.html',
        auth: {
            kind: null
        },
        serviceBaseURLs: {
            pc: `${BACKEND_BASE_URI}/`,
            quote: `${BACKEND_BASE_URI}/quote/`,
            vinlookup: `${BACKEND_BASE_URI}/quote/`,
            availability: `${BACKEND_BASE_URI}/quote/`,
            addresslookup: `${BACKEND_BASE_URI}/quote/`,
            baslertypelistmapping: `${BACKEND_BASE_URI}/quote/`,
            quotedocument: `${BACKEND_BASE_URI}/document/quote/quotedocument/`,
            companysearch: `${BACKEND_BASE_URI}/quote/`,
            dealersearch: `${BACKEND_BASE_URI}/quote/`,
        },
    },

    defaultLocaleDetails: {
        countryCode: 'US',
        mapCenter: {
            lat: 37.923933,
            lon: -122.5203,
        }
    },

    // Used for data of birth dropdowns
    AgeAllowedToDrive: 18,
    MaximumAge: 100,
    maxFileUploadSize: 50000000,

    ASYNC_TRANSLATIONS: true, // Constant that allows us to load translations synchronously (tests/Components Examples)
    ANGULARI18N_PRESET: '', // Constant that allows us to load Angular Locale from different path (Components Examples)
    TRANSLATE_PROVIDER_PREFIX: '', // Constant that allows us to load translations from different path (Components Examples)

    // custom configuration parameters
    configBasler: {

        isLocal: false,

        // Tracking parameters for this specific environments.
        // Bear in mind: for changing features by product, search for features.json

        magnoliaAssets: {
            url: "https://acc-www.baloise.ch/dam/baloise-ch/applications/praemienrechner/",
        },
        tracking :{
            googleAnalytics:{
                trackingID: "DUMMY TRACKING ID",
                url: "http://www.google.com",
            },

            segmentIO:{
                writeKey: "DUMMY WRITE KEY",
            },
        },
        TCS_GTM_ID: 'GTM-5588S8', // Google Tag Manager identification for TCS
        BALOISE_GTM_ID: 'GTM-P9HFDR9', // Google Tag Manager identification for Baloise
    },
};



// WEBPACK FOOTER //
// ./config/global.js